/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */

import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import LOGO_BARKERS from 'assets/images/basket/Barkers-logo.png';
import step1 from 'assets/images/basket/basket-step-1.svg';
import step2 from 'assets/images/basket/basket-step-2.svg';
import step3 from 'assets/images/basket/basket-step-3.svg';
import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import ExternalLink from 'components/generic/ExternalLink.component';
import Icon from 'components/generic/Icon.component';
import CurrencySign from 'components/price/CurrencySign.component';
import S from 'constants/string.const';
import { LOCALE, withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonIsBarkers, selectCurrentSalonIsLoreal, selectCurrentSalonName } from 'selectors/currentSalon.selectors';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import { exportCSV } from 'utils/converters/csv.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { formatDayToYear } from 'utils/date/format.util';
import { nowAsTimestamp } from 'utils/date/now.util';
import logger from 'utils/logger.util';
import createNodeKey from 'utils/react/createNodeKey.util';
import fixed from 'utils/values/fixed.util';
import parsfixed from 'utils/values/parsfixed.util';

import SimpleDialog from 'scheduler/components/SimpleDialog';
import { BasketItem } from 'stocks/components/common/BasketItem';
import { stockOrderingPdfGenerator } from 'stocks/components/common/utils/stockOrderingPdfGenerator';
import { STOCK_HOLDING_PDF_TABLE_ID, STOCK_ORDERING_PDF_TABLE_ID } from 'stocks/consts';

import CN from './TableStocksOrdering.module.scss';

const CTAG = 'TableStocksOrdering';
const L = logger(CTAG);

const USE_LOREAL = false;

const LINK_ROADMAP = 'https://barkershairdressing.com/';
const LINK_MAIL = 'mailto:sales@barkershairdressing.com';

const TODAY = fromAnyToTrimmed(formatDayToYear(nowAsTimestamp()));

class TableStocksOrdering extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteProductModal: false,
      orderModal: false,
      toggleBasket: true,
      emptyBasketModal: false,
      lastOrderModal: false,
      email: 'mbliok@melontech.com', // '',  EMAIL send
      printModal: false,
      deleteBasketItem: null,
      modalCSVinfo: true,
      barkersModal: false,
    };
  }

  componentDidMount() {
    this.getWindowScrollTop();
  }

  onClose = () => void this.setState({ deleteProductModal: false, emptyBasketModal: false, lastOrderModal: false });
  onDelete = () => void this.setState({});
  onDeleteProductModal = (itemDelete) => void this.setState({ deleteBasketItem: itemDelete });

  onDeleteOrderItem = () => {
    if (this.state.deleteBasketItem) {
      this.props.deleteOrderItem(this.state.deleteBasketItem);
      this.setState({ deleteBasketItem: null });
    }
  };
  onIncrement = (editItem) => {
    const item = editItem;
    item.quantity = editItem.quantity + 1;
    this.props.editOrderItem(item);
  };

  onDecrement = (editItem) => {
    const item = editItem;
    let value = editItem.quantity - 1;
    if (value < 1) {
      value = 1;
    }
    item.quantity = value;
    this.props.editOrderItem(item);
  };

  onEmptyBasketModal = () => {
    if (this.props.emptyBasket) {
      this.setState({ emptyBasketModal: true });
    }
  };

  onEmptyBasketClick = () => {
    this.props.emptyOrderBasket(this.props.salonId);
    this.setState({ emptyBasketModal: false });
  };

  onLoadLastOrder = () => {
    this.props.getLastOrderData(this.props.salonId, true);
    this.setState({ lastOrderModal: false });
  };

  getWindowScrollTop = () => {
    // TODO: remove this method, inline the code, it is used only once, same with the other 2 named the same
    if (window.pageYOffset) {
      return window.pageYOffset;
    } else if (document.documentElement) {
      return document.documentElement.scrollTop;
    }
    return 0;
  };

  showOrderModal = () => {
    this.setState({ orderModal: true });
    this.props.generateOrderData();
  };

  loadLastOrderModal = () => void this.setState({ lastOrderModal: true });
  closeOrderModal = () => void this.setState({ orderModal: false, barkersModal: false });
  toggleBasket = () => this.setState({ toggleBasket: !this.state.toggleBasket });

  searchFunc = (el) =>
    el
      .getName()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString(LOCALE.uk)
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[\u00E9]/g, '')
      .search(this.props.search) !== -1 ||
    el
      .getBrand()
      .trim()
      .normalize('NFD')
      .replace(/^0+'/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString(LOCALE.uk)
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    el
      .getFamily()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString(LOCALE.uk)
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    el
      .getCategory()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString(LOCALE.uk)
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    (el.barcode ? el.barcode.toString() : '')
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1;

  sendReceiptToEmail = () => {};

  generateCSV = ({ showModal }) => {
    const { csvData, t } = this.props;
    L.warn('generateCSV()', 'csvData:', csvData);

    // images with state - not working on some iPad
    const CSVinfo = document.querySelector('.dialog-container.no-show.csv-info-modal');
    if (CSVinfo && fromAnyToBool(showModal)) {
      CSVinfo.style.display = 'inline-flex';
    }

    const normalizedCsvData = csvData.map((item) => ({
      [t('stocks.stockOrderingDownloadFile.tableHeaders.barcode')]: item.barcode ?? '',
      [t('stocks.stockOrderingDownloadFile.tableHeaders.brand')]: item.brand ?? '',
      [t('stocks.stockOrderingDownloadFile.tableHeaders.subBrand')]: item.sub_brand ?? '',
      [t('stocks.stockOrderingDownloadFile.tableHeaders.product')]: item.title ?? '',
      [t('stocks.stockOrderingDownloadFile.tableHeaders.quantity')]: item.quantity,
    }));

    exportCSV({
      data: normalizedCsvData,
      fileName: `${t('stocks.stockOrderingBasket.generateOrderModal.csvFileName', { date: TODAY })}.csv`,
    });

    this.setState({ orderModal: false });
  };

  generateBarkersCsv = () => {
    const { salonName, csvData, t } = this.props;

    const normalizedBarkersCsvData = csvData.map((item) => ({
      [t('stocks.stockOrderingDownloadFile.tableHeaders.barcode')]: item.barcode ?? '',
      [t('stocks.stockOrderingDownloadFile.tableHeaders.product')]: item.title ?? '',
      [t('stocks.stockOrderingDownloadFile.tableHeaders.quantity')]: item.quantity ?? 0,
    }));

    exportCSV({
      data: normalizedBarkersCsvData,
      fileName: `${t('stocks.stockOrderingBasket.barkersModal.csvFileName', {
        salonName,
        date: TODAY,
      })}.csv`,
    });
  };

  modalDisplayHidden = () => {
    const CSVinfo = document.querySelector('.dialog-container.no-show.csv-info-modal');
    if (CSVinfo) {
      CSVinfo.style.display = 'none';
    }
  };

  generateStockOrderingPdf = () =>
    stockOrderingPdfGenerator({
      salonName: this.props.salonName,
      geratedOrderNumber: this.props.geratedOrderNumber,
      date: TODAY,
      t: this.props.t,
    });

  showBarkersModal = () => {
    this.setState({ barkersModal: true, orderModal: false });
  };

  render() {
    const { isLorealSalon, isBarkersSalon, t } = this.props;
    const brandKeys = Object.keys(this.props.data).sort((s1, s2) => s1.localeCompare(s2));
    const orderKeys = Object.keys(this.props.orderItems).sort((s1, s2) => s1.localeCompare(s2));

    return (
      <div>
        <div className="tbl-container move-down">
          <table className="table-stocks-body" id={STOCK_HOLDING_PDF_TABLE_ID}>
            <thead className="stock-holding-nav tbl-stock-fixed-header">
              <tr>
                <td className="cbox" style={{ width: '40px' }}>
                  <div className="checkbox-box-custom-wrap">
                    <input type="checkbox" className="checkbox-box-custom" id="cbAll" checked={this.props.allItemsSelected} onChange={this.props.toogleCheckAll} />
                    <label className="checkbox-box-label" htmlFor="cbAll">
                      <div className="checkbox-box-custom-icon">
                        <span className="ic-sml-18px ic_check_white_18" />
                      </div>
                    </label>
                  </div>
                </td>
                <td className="product-name">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.onAddSort('title');
                    }}
                  >
                    {t('stocks.tableHeaders.productName')}
                    {/* <img src={sortIcon} alt="Sort by product" /> */}
                  </span>
                </td>
                <td>
                  <span role="button" tabIndex={0} onClick={() => {}}>
                    <span>{t('stocks.tableHeaders.stockQuantity')}</span>
                  </span>
                </td>
                <td>
                  <span role="button" tabIndex={0} onClick={() => {}}>
                    <span>{t('stocks.tableHeaders.minHolding')}</span>
                  </span>
                </td>
                <td>
                  <span role="button" tabIndex={0} onClick={() => {}}>
                    <span>{t('stocks.tableHeaders.maxHolding')}</span>
                  </span>
                </td>
                <td>
                  <span role="button" tabIndex={0} onClick={() => {}}>
                    <span>{t('stocks.tableHeaders.usedLast30d')}</span>
                  </span>
                </td>
                <td className="pink-bgr">
                  <span role="button" tabIndex={0} onClick={() => {}}>
                    {t('stocks.tableHeaders.suggestedOrder')}
                  </span>
                </td>
              </tr>
            </thead>
            <tbody>
              {brandKeys.map((key) => {
                const brand = this.props.data[key];
                const subCategoryKeys = Object.keys(brand).sort((s1, s2) => s1.localeCompare(s2));
                return subCategoryKeys.map((catKey) => {
                  const subCategory = brand[catKey];
                  const categoryArr = Object.values(subCategory);
                  const stockList = [];
                  for (let i = 0; i < categoryArr.length; i += 1) {
                    stockList.push(...categoryArr[i]);
                  }
                  let stocks = stockList.filter(this.searchFunc).sort((s1, s2) => s1.title.localeCompare(s2.title));
                  if (this.props.lowInStock) {
                    stocks = stocks.filter((c) => (c.units_in_stock || c.max_in_stock ? c.max_in_stock - c.units_in_stock > 0 : false));
                  } else {
                    stocks = stockList.filter(this.searchFunc).sort((s1, s2) => s1.title.localeCompare(s2.title));
                  }
                  if (!stocks.length) {
                    return <tr />;
                  }
                  return (
                    <Fragment key={`${key}-${catKey}`}>
                      <tr>
                        <td className="row-checkbox-cbox" style={{ width: '40px', backgroundColor: '#630396' }} />
                        <td colSpan="3" className="brand-family-banner">
                          <div>
                            {key} - {catKey}
                          </div>
                        </td>
                        <td className="beta" />
                        <td className="beta" />
                        <td className="beta" />
                      </tr>
                      {stocks.map((stock) => {
                        let suggestedOrder = '-';
                        if (stock.max_in_stock) {
                          const averageOrder = stock.max_in_stock - stock.units_in_stock;
                          if (averageOrder < 0) {
                            suggestedOrder = '0';
                          } else {
                            suggestedOrder = averageOrder.toFixed();
                          }
                        }
                        return (
                          <tr key={stock.id}>
                            {/* NOTE: `id` is used to identify and hide the checkbox row in the pdf generator */}
                            <td className="row-checkbox-cbox" style={{ width: '40px' }} id={`row-checkbox-${stock.id}`}>
                              {stock.isInBasket && <span id="added-to-basket-icon" />}
                              {!stock.isInBasket && (
                                <div className="checkbox-box-custom-wrap">
                                  <input
                                    type="checkbox"
                                    className="checkbox-box-custom"
                                    id={`stocks-check-${stock.id}`}
                                    checked={stock.selected}
                                    onChange={() => {
                                      this.props.toggleOrderItem(stock, !stock.selected);
                                    }}
                                  />
                                  <label className="checkbox-box-label" htmlFor={`stocks-check-${stock.id}`}>
                                    <div className="checkbox-box-custom-icon">
                                      <span className="ic-sml-18px ic_check_white_18" />
                                    </div>
                                  </label>
                                </div>
                              )}
                            </td>
                            <td
                              role="button"
                              tabIndex={0}
                              className="product-name text-upper"
                              //   onClick={() => {
                              //   this.props.OnClickRow(stock);
                              // }}
                            >
                              {stock.title}
                            </td>
                            <td>{parsfixed(stock.units_in_stock)}</td>
                            <td>{stock.min_in_stock ? stock.min_in_stock : '-'}</td>
                            <td>{stock.max_in_stock ? stock.max_in_stock : '-'}</td>
                            <td>{fixed(parseFloat(stock.sold_last_30_days) + parseFloat(stock.used_last_30_days))}</td>
                            <td className="pink-bgr">{suggestedOrder}</td>
                          </tr>
                        );
                      })}
                    </Fragment>
                  );
                });
              })}
              {this.props.data.length === 0 && (
                <tr>
                  <td style={{ textAlign: 'center' }}>{t('stocks.stockManagerTable.noProductsMsg')}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* BASKET */}
        <div className={this.state.toggleBasket ? 'basket-sidebar' : 'basket-sidebar mobile'}>
          <div>
            <div className="basket-header">
              <div>
                <span>{t('stocks.stockOrderingBasket.products')}</span>
                <span>{this.props.orderItemsCount}</span>
              </div>
              <div className="basket-icon" role="button" tabIndex={0} onClick={this.toggleBasket} />
              <div>
                <span>{t('stocks.stockOrderingBasket.cost')}</span>
                <span>
                  <CurrencySign value={this.props.totalOrderItemsCost} />
                </span>
              </div>
            </div>
            <div className="basket-content">
              {!this.props.emptyBasket && (
                <div className="empty">
                  <p>{t('stocks.stockOrderingBasket.selectProductDescriptionPart1')}</p>
                  <p>{t('stocks.stockOrderingBasket.selectProductDescriptionPart2')}</p>
                </div>
              )}
              {this.props.emptyBasket && (
                <div className="basket-products">
                  {orderKeys.map((key) => {
                    const orderBrand = this.props.orderItems[key];
                    const subBrandKeys = Object.keys(orderBrand).sort((s1, s2) => s1.localeCompare(s2));
                    return (
                      <div>
                        <div className="basket-brand-banner">{key}</div>
                        {subBrandKeys.map((subKey) => {
                          const subCategory = orderBrand[subKey];

                          const stockListObj = Object.values(subCategory).map((e) => [...e]);
                          const stockListArr = Object.values(stockListObj);
                          const stockList = [];
                          for (let i = 0; i < stockListArr.length; i += 1) {
                            if (stockListArr[i]) {
                              stockList.push(...stockListArr[i]);
                            }
                          }
                          const items = stockList;
                          return (
                            <div>
                              <div className="tbl-products-container">
                                <table className="tbl-products">
                                  {items.map((product, index) => (
                                    <tr className="header-sub-brand" key={createNodeKey({ index, tag: product.sub_brand })}>
                                      <th className="cell-name">{product.sub_brand}</th>
                                      <th className="cell-q">{t('stocks.stockOrderingBasket.quantity')}</th>
                                      <th className="cell-price">{t('stocks.stockOrderingBasket.price')}</th>
                                      <th className="cell-total">{t('stocks.stockOrderingBasket.subtotal')}</th>
                                      <th className="cell-del" />
                                    </tr>
                                  ))}

                                  {items.map((product) => (
                                    <BasketItem orderItem={product} onDelete={this.onDeleteProductModal} onIncrement={this.onIncrement} onDecrement={this.onDecrement} />
                                  ))}
                                </table>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                  <div style={{ backgroundColor: 'gray' }} />
                </div>
              )}
            </div>
            <div className="basket-footer">
              <div className="flex-btns">
                <button className="btn btn-violet" onClick={this.props.saveBasket}>
                  {this.props.basketSaved ? t('stocks.stockOrderingBasket.basketSavedButton') : t('stocks.stockOrderingBasket.saveBasketButton')}
                </button>
                <button className="btn btn-outline" onClick={this.onEmptyBasketModal}>
                  {t('stocks.stockOrderingBasket.emptyBasketButton')}
                </button>
              </div>
              <div className="flex-btns">
                <button className="btn btn-blue" onClick={this.showOrderModal} disabled={this.props.orderItemsCount === 0}>
                  {t('stocks.stockOrderingBasket.generateOrderButton')}
                </button>
                <button className="btn btn-outline blue" onClick={this.loadLastOrderModal}>
                  {t('stocks.stockOrderingBasket.loadLastOrderButton')}
                </button>
              </div>
            </div>
          </div>
          {/* BASKET END */}

          {this.state.deleteBasketItem && (
            <SimpleDialog
              title=" "
              leftButtonText={t('common.buttons.cancel')}
              rightButtonText={t('common.buttons.yes')}
              onLeft={() => {
                this.setState({ deleteBasketItem: null });
              }}
              onRight={this.onDeleteOrderItem}
              displayHeader="header-non"
              uniqueClass="wide-btn"
              isOpen={this.state.deleteBasketItem}
            >
              <div className="dialog-inner-title">{t('stocks.stockOrderingBasket.removeProductModal.title')}</div>
              <div className="dialog-text" style={{ padding: '12px', lineHeight: '22px' }}>
                {t('stocks.stockOrderingBasket.removeProductModal.description', {
                  product: this.state.deleteBasketItem.title,
                })}
              </div>
            </SimpleDialog>
          )}
          {this.state.emptyBasketModal && this.props.emptyBasket && (
            <SimpleDialog
              title=" "
              leftButtonText={t('common.buttons.cancel')}
              rightButtonText={t('stocks.stockOrderingBasket.emptyBasketModal.confirmButton')}
              onLeft={this.onClose}
              onRight={this.onEmptyBasketClick}
              displayHeader="header-non"
              uniqueClass="wide-btn"
              isOpen={this.state.emptyBasketModal}
            >
              <div className="dialog-inner-title">{t('stocks.stockOrderingBasket.emptyBasketModal.title')}</div>
              <div className="dialog-text" style={{ padding: '12px', lineHeight: '22px' }}>
                {t('stocks.stockOrderingBasket.emptyBasketModal.description')}
              </div>
            </SimpleDialog>
          )}
          {this.state.lastOrderModal && (
            <SimpleDialog
              title=" "
              leftButtonText={t('common.buttons.cancel')}
              rightButtonText={t('stocks.stockOrderingBasket.lastOrderModal.confirmButton')}
              onLeft={this.onClose}
              onRight={this.onLoadLastOrder}
              displayHeader="header-non"
              uniqueClass="wide-btn"
              isOpen={this.state.lastOrderModal}
            >
              <div className="dialog-inner-title">{t('stocks.stockOrderingBasket.lastOrderModal.title')}</div>
              <div className="dialog-text" style={{ padding: '12px', lineHeight: '22px' }}>
                {t('stocks.stockOrderingBasket.lastOrderModal.description')}
              </div>
            </SimpleDialog>
          )}

          {fromAnyToBool(this.state.orderModal) && (
            <SalonModal tag="StockOrderModal" isOpen={this.state.orderModal} variant="medium">
              <SalonModal.Header>
                {t('stocks.stockOrderingBasket.generateOrderModal.title')}
                <Button variant="empty" onClick={this.closeOrderModal}>
                  <Icon variant="close" />
                </Button>
              </SalonModal.Header>
              <SalonModal.Body>
                <div className={CN.modalContainer}>
                  <div className={CN.modalSubtitle}>{t('stocks.stockOrderingBasket.generateOrderModal.description')}</div>
                  <div className={CN.modalButtons}>
                    <button className={CN.buttonExcel} onClick={() => this.generateCSV({ showModal: false })}>
                      {t('stocks.stockOrderingBasket.generateOrderModal.downloadSpreadsheetButton')}
                    </button>
                    <button className={CN.buttonPdf} onClick={this.generateStockOrderingPdf}>
                      {t('stocks.stockOrderingBasket.generateOrderModal.generatePdfButton')}
                    </button>
                  </div>

                  <div className={CN.logoContainer}>
                    {isBarkersSalon && <button onClick={this.showBarkersModal} className={CN.logoBarkers} />}
                    {(isLorealSalon || USE_LOREAL) && <button onClick={() => this.generateCSV({ showModal: true })} className={CN.logoLoreal} />}
                  </div>
                </div>
              </SalonModal.Body>
            </SalonModal>
          )}

          {fromAnyToBool(this.state.barkersModal) && (
            <SalonModal tag="StockOrderModal" isOpen={this.state.barkersModal} variant="medium">
              <SalonModal.Header>
                {t('stocks.stockOrderingBasket.barkersModal.title')}
                <Button variant="empty" onClick={this.closeOrderModal}>
                  <Icon variant="close" />
                </Button>
              </SalonModal.Header>
              <SalonModal.Body>
                <div className={CN.modalContainer}>
                  <img src={LOGO_BARKERS} className={CN.logo} alt="Barkers logo" />
                  <div className={CN.modalText}>
                    <p>
                      <ExternalLink link={LINK_ROADMAP} variant="inline">
                        <span className={CN.link}>
                          {t('stocks.stockOrderingBasket.barkersModal.descriptionPart1')} {S.space}
                        </span>
                      </ExternalLink>
                      {t('stocks.stockOrderingBasket.barkersModal.descriptionPart2')}
                    </p>
                    <p>{t('stocks.stockOrderingBasket.barkersModal.descriptionPart3')}</p>
                    <p>
                      {t('stocks.stockOrderingBasket.barkersModal.descriptionPart4')}
                      <ExternalLink link={LINK_MAIL} variant="inline">
                        <span className={CN.mail}>{t('stocks.stockOrderingBasket.barkersModal.descriptionPart5')}</span>
                      </ExternalLink>
                    </p>
                  </div>

                  <div className={CN.modalButtons}>
                    <button className={CN.buttonExcel} onClick={this.generateBarkersCsv}>
                      {t('stocks.stockOrderingBasket.barkersModal.exportExcelButton')}
                    </button>
                    <button className={CN.buttonPdf} onClick={this.generateStockOrderingPdf}>
                      {t('stocks.stockOrderingBasket.barkersModal.generatePdfButton')}
                    </button>
                  </div>
                </div>
              </SalonModal.Body>
            </SalonModal>
          )}

          <SimpleDialog
            title={t('stocks.stockOrderingBasket.lorealModal.title')}
            leftButtonText=""
            rightButtonText=""
            onCancel={this.modalDisplayHidden}
            onLeft={() => {}}
            onRight={() => {}}
            // displayHeader="header-non"
            uniqueClass="csv-info-modal"
            isOpen={this.state.modalCSVinfo}
          >
            <div className="top-text">
              <a href="https://www.lorealpartnershop.com/uk/en/login/" target="_blank" rel="noopener noreferrer">
                {t('stocks.stockOrderingBasket.lorealModal.description1Part1')}&nbsp;
              </a>
              {t('stocks.stockOrderingBasket.lorealModal.description1Part2')}
            </div>
            <div className="steps s1">
              <div>{t('stocks.stockOrderingBasket.lorealModal.bullet1')}</div>
              <img src={step1} alt="Click on basket" />
            </div>
            <div className="steps s2">
              <div>
                {t('stocks.stockOrderingBasket.lorealModal.bullet2')} <p />
                {t('stocks.stockOrderingBasket.lorealModal.bullet3Part1')}
                <strong>{t('stocks.stockOrderingBasket.lorealModal.bullet3Part2')}</strong> {t('stocks.stockOrderingBasket.lorealModal.bullet3Part3')}
              </div>
              <img src={step2} alt="Choose file" />
            </div>
            <div className="steps s3">
              <div>{t('stocks.stockOrderingBasket.lorealModal.bullet4')}</div>
              <img src={step3} alt="Upload CSV file" />
            </div>
            <div className="steps s3">
              <br />
              <div>{t('stocks.stockOrderingBasket.lorealModal.noteMessage')}</div>
            </div>
          </SimpleDialog>

          {/*
                     PDF start

                     Workaround for issue to hide pdf
                     SEE: https://getslick.atlassian.net/browse/GS-11052
                     */}

          <table id={STOCK_ORDERING_PDF_TABLE_ID} style={{ display: 'none', top: '101vh', left: '101vw' }}>
            <thead>
              <tr>
                <th>{t('stocks.stockOrderingDownloadFile.tableHeaders.eanBarcode')}</th>
                <th>{t('stocks.stockOrderingDownloadFile.tableHeaders.brand')}</th>
                <th>{t('stocks.stockOrderingDownloadFile.tableHeaders.subBrand')}</th>
                <th>{t('stocks.stockOrderingDownloadFile.tableHeaders.product')}</th>
                <th>{t('stocks.stockOrderingDownloadFile.tableHeaders.quantity')}</th>
              </tr>
            </thead>
            <tbody>
              {this.props.emptyBasket && (
                <>
                  {orderKeys.map((key) => {
                    const orderBrand = this.props.orderItems[key];
                    const subBrandKeys = Object.keys(orderBrand).sort((s1, s2) => s1.localeCompare(s2));
                    return (
                      <>
                        {subBrandKeys.map((subKey) => {
                          const subCategory = orderBrand[subKey];

                          const stockListObj = Object.values(subCategory).map((e) => [...e]);
                          const stockListArr = Object.values(stockListObj);
                          const stockList = [];
                          for (let i = 0; i < stockListArr.length; i += 1) {
                            if (stockListArr[i]) {
                              stockList.push(...stockListArr[i]);
                            }
                          }
                          const items = stockList;
                          return (
                            <>
                              {items.map((product) => (
                                <tr key={product.product}>
                                  <td>{product.barcode}</td>
                                  <td>{key.replace(/’/, "'")}</td>
                                  <td>{product.sub_brand}</td>
                                  <td>{product.title}</td>
                                  <td>{product.quantity}</td>
                                </tr>
                              ))}
                            </>
                          );
                        })}
                      </>
                    );
                  })}
                </>
              )}
            </tbody>
          </table>
          {/* PDF end */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  salonName: selectCurrentSalonName(state),
  isBarkersSalon: selectCurrentSalonIsBarkers(state),
  isLorealSalon: selectCurrentSalonIsLoreal(state),
});

const TableStocksOrderingHoc = connect(mapStateToProps)(withTranslation()(TableStocksOrdering));

export default TableStocksOrderingHoc;
